import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ClockIconComponent } from '../../ui';

@Component({
  selector: 'app-session-expired-modal',
  standalone: true,
  imports: [TranslatePipe, ClockIconComponent],
  templateUrl: './session-expired-modal.component.html',
  styleUrl: './session-expired-modal.component.scss'
})
export class SessionExpiredModalComponent {
  @Input() open = false;
  @Output() reconnect = new EventEmitter<void>();

  onReconnect(): void {
    this.reconnect.emit();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: Event): void {
    if (this.open) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
